import createNamespaceContext from './helper/createNamespaceContext';
export var ATLAS_CONTEXT = 'atlasCtx';
export var AtlasAnalyticsContext = createNamespaceContext(ATLAS_CONTEXT, 'AtlasAnalyticsContext');